import { BASE_SERVER_URL } from "../constants"
import loginService from "./loginService"
import axios from "axios"

const uploadImage = (file) => {
    if (!file) {
        console.log("uploadImage: file: ", file)
        return
    }

    const URL = `${BASE_SERVER_URL}/images/upload`
    try {
        const formData = new FormData()
        formData.append("image", file)
        return loginService.getCredentials()
            .then(creds => {
                const config = {
                    headers: {
                        Authorization: creds.accessToken,
                        "Content-Type": "multipart/form-data",
                    }
                }
                return axios.post(URL, formData, config)
                    .then(res => {
                        console.log("Upload success:", res.data)
                        return res.data
                    }).catch(err => err)
            }).catch(err => err)
    } catch (err) {
        console.error(err)
    }
}

const extractFileNamefromFileUrl = (fileUrl) => {
    const fileUrlParts = fileUrl.split("/")
    if (fileUrlParts && fileUrlParts.length) {
        // /images/uploads/1742405431450.png
        console.log("fileUrlParts", fileUrlParts)
        return fileUrlParts[fileUrlParts.length-1]
    }
}

const updateImage = (file, oldFileName) => {
    if (!file) {
        console.log("updateImage: file: ", file)
        return
    }

    const URL = `${BASE_SERVER_URL}/images/${oldFileName}`
    try {
        const formData = new FormData()
        formData.append("image", file)
        return loginService.getCredentials()
            .then(creds => {
                const config = {
                    headers: {
                        Authorization: creds.accessToken,
                        "Content-Type": "multipart/form-data",
                    }
                }
                return axios.put(URL, formData, config)
                    .then(res => {
                        console.log("updateImage success:", res.data)
                        return res.data
                    }).catch(err => err)
            }).catch(err => err)
    } catch (err) {
        console.error(err)
    }
}

const deleteImage = (fileName) => {
    const URL = `${BASE_SERVER_URL}/images/${fileName}`

    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken,
                }
            }
            return axios.delete(URL, config)
                .then(res => {
                    console.log("Delete image success:", res.data)
                    return res.data
                }).catch(err => err)
        }).catch(err => err)
}


export default {deleteImage, updateImage, uploadImage, extractFileNamefromFileUrl}